import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import AppProvider from './AppContext.tsx';
import { AuthProvider } from './context/AuthContext';
import {
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import Home from './pages/Home.tsx';
import Verifications from './pages/Verifications.tsx';
import Stamps from './pages/Stamps.tsx';
import Details from './pages/Details.tsx';
import ErrorBoundary from './errorBoundries.tsx';
// import DetailsPdfOLD from './pages/DetailsPdfOLD.tsx';
import DetailsPDF from './pages/DetailsPdf.tsx';
import About from './pages/About.tsx';
import ReportIssue from './pages/ReportIssue.tsx';
import StampData from './pages/StampData.tsx';
import Login from './pages/Login.tsx';
import ProtectedRoute from './components/ProtectedRoute';

const router = createHashRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route
        index
        element={
          <ProtectedRoute>
            <StampData />
          </ProtectedRoute>
        }
      />
      <Route path="login" element={<Login />} />
      <Route
        path="analyze"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="verifications"
        element={
          <ProtectedRoute>
            <Verifications />
          </ProtectedRoute>
        }
      />
      <Route
        path="stamps"
        element={
          <ProtectedRoute>
            <Stamps />
          </ProtectedRoute>
        }
      />
      <Route
        path="about"
        element={
          <ProtectedRoute>
            <About />
          </ProtectedRoute>
        }
      />
      <Route
        path="report-issue"
        element={
          <ProtectedRoute>
            <ReportIssue />
          </ProtectedRoute>
        }
      />
      <Route
        path="details/:id"
        element={
          <ProtectedRoute>
            <Details />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="document/:id"
        element={
          <ProtectedRoute>
            <DetailsPdfOLD />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path="pdf/:id"
        element={
          <ProtectedRoute>
            <DetailsPDF />
          </ProtectedRoute>
        }
      />
    </Route>,
  ),
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <AppProvider>
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </AppProvider>
    </AuthProvider>
  </React.StrictMode>,
);
